<template>
  <div class="dynamic-chart">
    <div style="margin-bottom: 10px">
      <bx-btn @click="openPicker('days')" class="mr-2">Days</bx-btn>
      <bx-btn @click="openPicker('months')" class="mr-2">Months</bx-btn>
      <bx-btn @click="openPicker('years')">Years</bx-btn>
    </div>

    <apexchart
      ref="chart"
      type="area"
      width="100%"
      height="400"
      :options="options"
      :series="series"
    ></apexchart>

    <v-dialog width="700" v-model="dialog">
      <v-card>
        <v-card-title>Select Range</v-card-title>
        <v-card-text>
          <v-container v-if="tempGranularity === 'days'">
            <v-row>
              <v-col>
                Start date:
                <v-date-picker
                  :allowed-dates="allowedDatesStart"
                  v-model="graph.date_start"
                ></v-date-picker>
              </v-col>
              <v-col>
                End date:
                <v-date-picker
                  :allowed-dates="allowedDatesEnd"
                  v-model="graph.date_end"
                ></v-date-picker>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="tempGranularity === 'months'">
            <v-row>
              <v-col style="min-height: 235px">
                Start month:
                <vue-monthly-picker
                  v-model="graph.date_start"
                ></vue-monthly-picker>
              </v-col>
              <v-col style="min-height: 235px" v->
                End month:
                <vue-monthly-picker
                  v-model="graph.date_end"
                ></vue-monthly-picker>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-if="tempGranularity === 'years'">
            <v-row>
              <v-col style="min-height: 235px">
                Start year:
                <v-select
                  :items="allowedStartYear"
                  v-model="graph.date_start"
                />
              </v-col>
              <v-col style="min-height: 235px">
                End year:
                <v-select :items="allowedEndYear" v-model="graph.date_end" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn @click="closeDialog" color="primary">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import VueMonthlyPicker from "vue-monthly-picker";

export default {
  props: ["locationId", "module", "title"],
  components: {
    VueMonthlyPicker
  },
  data() {
    return {
      dialog: false,
      years: [],
      graph: {
        granularity: "days",
        date_start: "",
        date_end: ""
      },
      tempGranularity: "days",
      options: {
        chart: {
          id: "vuechart-example",
          zoom: {
            enabled: true
          },
          toolbar: {
            show: true
          }
        },
        xaxis: {
          show: true,
          type: "datetime"
        },
        responsive: [
          {
            breakpoint: 769,
            options: {
              chart: {
                zoom: {
                  enabled: false
                },
                toolbar: {
                  show: false
                }
              }
            }
          }
        ],
        tooltip: {
          x: {
            formatter: function(value) {
              return moment(value).format("DD/MM/YYYY");
            }
          }
        },
        title: {
          text: this.title
        },
        noData: {
          text: "Loading..."
        }
      },
      series: []
    };
  },
  watch: {
    locationId(locationId) {
      if (locationId) {
        this.updateChart();
      }
    }
  },
  mounted() {
    const startOfMonth = moment()
      .subtract(60, "days")
      .format("YYYY-MM-DD");
    const currentDate = moment().format("YYYY-MM-DD");
    this.graph.date_start = startOfMonth;
    this.graph.date_end = currentDate;

    this.generateYearArray();
  },
  computed: {
    allowedStartYear() {
      return this.years.filter(
        x => parseInt(x) < parseInt(this.graph.date_end)
      );
    },
    allowedEndYear() {
      return this.years.filter(
        x => parseInt(x) > parseInt(this.graph.date_start)
      );
    }
  },
  methods: {
    generateYearArray() {
      for (let index = 0; index < 50; index++) {
        let year = moment()
          .subtract(index, "years")
          .format("YYYY");
        this.years.push(year);
      }
    },
    allowedDatesStart(val) {
      var date = moment(val);
      var endDate = moment(this.graph.date_end);
      var now = moment();

      return now > date && date < endDate;
    },
    allowedDatesEnd(val) {
      var date = moment(val);
      var startDate = moment(this.graph.date_start);
      var now = moment();

      return now > date && date > startDate;
    },
    openPicker(granularity) {
      this.tempGranularity = granularity;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.updateChart(this.tempGranularity);
    },
    updateChart(value) {
      let granularity = value || this.graph.granularity;
      if (value) {
        this.graph.granularity = value;
      }
      let startDate = moment(this.graph.date_start);
      let endDate = moment(this.graph.date_end);
      let diffInDays = endDate.diff(startDate, "days");

      if (granularity === "days") {
        if (Math.abs(diffInDays) > 60) {
          this.graph.date_start = moment(this.graph.date_end)
            .subtract(60, "days")
            .format("YYYY-MM-DD");
        }
      }
      if (granularity === "months") {
        this.graph.date_start = moment(this.graph.date_start).format("YYYY-MM");
        this.graph.date_end = moment(this.graph.date_end).format("YYYY-MM");
        if (startDate >= endDate) {
          this.graph.date_end = moment(this.graph.date_start)
            .add(2, "month")
            .format("YYYY-MM");
        }
      }
      this.getGraphStatistics();
    },
    async getGraphStatistics() {
      let _this = this;
      if (
        !this.graph.date_start ||
        !this.graph.date_end ||
        !this.$refs.chart.updateOptions
      ) {
        return;
      }
      let locationId = this.locationId;
      // _this.series = []

      const data = await this.$api.location.graphStatistics(
        locationId,
        this.module,
        {
          granularity: this.graph.granularity,
          date_start: this.graph.date_start,
          date_end: this.graph.date_end
        }
      );

      let chartData = data && this.mapSeriesXaxis(data.x_axis, data.series);
      if (_this.series.length) {
        this.series = chartData.series;
      } else {
        chartData.series.forEach(item => {
          _this.series.push({
            data: item.data,
            name: item.name
          });
        });
      }

      this.$refs.chart &&
        this.$refs.chart.updateOptions({
          xaxis: {
            show: true,
            type: "datetime",
            categories: chartData.xAxis
          }
        });
    },
    mapSeriesXaxis(xAxis, series) {
      if (this.graph.granularity === "years") {
        series.map(s => {
          xAxis.forEach((x, i) => {
            s.data[i] = [
              moment(x, "YYYY")
                .toDate()
                .getTime(),
              s.data[i]
            ];
          });
          return s;
        });

        return { xAxis, series };
      }

      if (this.graph.granularity === "months") {
        series.map(s => {
          xAxis.forEach((x, i) => {
            s.data[i] = [
              moment(x, "MMMM")
                .toDate()
                .getTime(),
              s.data[i]
            ];
          });
          return s;
        });

        return { xAxis, series };
      }

      if (this.graph.granularity === "days") {
        series.map(s => {
          xAxis.forEach((x, j) => {
            s.data[j] = [
              moment(x)
                .toDate()
                .getTime(),
              s.data[j]
            ];
          });
          return s;
        });

        return { xAxis, series };
      }

      return { xAxis, series };
    }
  }
};
</script>

<style>
.v-dialog__content {
  z-index: 999 !important;
}
</style>
